import { useState } from 'react';

interface HeroProps {
  onSearch: (q: string) => void;
}

const ticker = [
  '新女团首专主打歌 MV 上线登顶热搜',
  '多地推行“居民议事亭”新模式',
  '新一代折叠旗舰正式发布',
  '亚洲杯预选赛今晚开战',
  '多城优化住房支持政策',
  '电竞赛事总决赛门票三秒售罄',
];

const stats = [
  { label: '今日瓜料', value: '128', unit: '条' },
  { label: '覆盖栏目', value: '8', unit: '个' },
  { label: '累计围观', value: '3800', unit: '万+' },
];

export default function Hero({ onSearch }: HeroProps) {
  const [query, setQuery] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(query);
    document.getElementById('feed')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-16 md:pt-20">
      {/* 装饰背景 */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl" />
        <div className="absolute -left-20 top-40 h-72 w-72 rounded-full bg-secondary-100/70 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 h-56 w-56 rounded-full bg-accent-100/70 blur-3xl" />
      </div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-8 px-4 pb-10 pt-8 md:px-6 lg:grid-cols-[1.1fr_1fr] lg:pb-16 lg:pt-14">
        <div className="text-center lg:text-left">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-50 px-3 py-1 text-xs font-semibold text-accent-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
            </span>
            今日瓜料 · 正在更新
          </span>

          <h1 className="mt-5 font-heading text-4xl font-bold leading-tight tracking-tight text-foreground-950 md:text-6xl">
            一站在手
            <br />
            <span className="bg-gradient-to-r from-primary-600 via-primary-500 to-accent-600 bg-clip-text text-transparent">
              吃瓜不愁
            </span>
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base lg:mx-0">
            吃瓜大全热门事件合集，每日更新今日汇总与最新瓜料，热点事件打包整理。娱乐、社会、科技、体育、财经一网打尽，帮你快速掌握“今天发生了什么”。
          </p>

          <form onSubmit={submit} className="mx-auto mt-7 max-w-xl lg:mx-0">
            <div className="flex items-center gap-1 rounded-xl border border-background-300 bg-background-50 p-1.5 shadow-card">
              <i className="ri-search-line pl-2 text-lg text-foreground-400" />
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索你关心的热点，例如：折叠屏、博物馆夜游…"
                className="h-11 w-full bg-transparent px-2 text-sm outline-none placeholder:text-foreground-400"
              />
              <button
                type="submit"
                className="h-11 shrink-0 whitespace-nowrap rounded-lg bg-primary-500 px-5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                搜索瓜料
              </button>
            </div>
          </form>

          <dl className="mx-auto mt-8 grid max-w-md grid-cols-3 divide-x divide-background-300 lg:mx-0">
            {stats.map((s) => (
              <div key={s.label} className="px-4 text-center lg:first:pl-0">
                <dt className="text-xs text-foreground-500">{s.label}</dt>
                <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  {s.value}
                  <span className="text-sm font-semibold text-accent-600">{s.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 右侧卡片展示 + 跑马灯 */}
        <div className="relative">
          <div className="overflow-hidden rounded-3xl border border-background-200 bg-background-100/80 p-4 shadow-card">
            <div className="flex items-center justify-between px-1 pb-3">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-flashlight-line" />
                </span>
                <span className="font-heading text-lg font-bold text-foreground-950">今日瓜速递</span>
              </div>
              <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800">
                实时滚动
              </span>
            </div>
            <ul className="space-y-2">
              {ticker.map((t, i) => (
                <li
                  key={t}
                  className="flex items-center gap-3 rounded-xl bg-background-50 px-3 py-2.5"
                >
                  <span className="font-heading text-sm font-bold text-accent-600">#{String(i + 1).padStart(2, '0')}</span>
                  <span className="truncate text-sm text-foreground-800">{t}</span>
                </li>
              ))}
            </ul>
            <div className="mt-3 flex items-center gap-2 rounded-xl bg-secondary-100/70 px-3 py-2.5">
              <i className="ri-arrow-left-right-line text-lg text-secondary-700" />
              <p className="text-xs leading-relaxed text-secondary-800">
                榜单每隔 5 分钟自动刷新，瓜料正在源源不断地汇聚……
              </p>
            </div>
          </div>

          <div className="absolute -bottom-3 left-4 hidden items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-600 shadow-card lg:flex">
            <i className="text-accent-600 ri-verified-badge-fill" />
            瓜料来源：多方信源交叉核实
          </div>
        </div>
      </div>
    </section>
  );
}